export enum AdminUsersRoutes {
  CreateUser = 'create-user',
  DeleteUsers = 'delete-users',
  GetResetPasswordUrl = 'get-reset-password-url',
  GetUser = 'get-user',
  GetUsers = 'get-users',
  MakeAnnouncement = 'make-announcement',
  UpdateUser = 'update-user',
}
